import { render, staticRenderFns } from "./AddSaleQuotation.vue?vue&type=template&id=fa76885a&"
import script from "./AddSaleQuotation.vue?vue&type=script&lang=js&"
export * from "./AddSaleQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports